import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { loadExperienceContext } from '../services/utils/loadExperienceContext'

const ExperienceInitializer = () => {
	const dispatch = useDispatch()
	const { experienceSlug, orgSlug } = useParams()

	useEffect(() => {
		if (!experienceSlug || !orgSlug) return
		loadExperienceContext(experienceSlug, orgSlug, dispatch)
	}, [dispatch, experienceSlug, orgSlug])

	return null
}

export default ExperienceInitializer
